import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Bot, BotMessageSquare, User } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
export type AIMode = 'auto' | 'suggestions' | 'manual';
interface AIAgentModeSelectorProps {
  currentMode: AIMode;
  loading: boolean;
  onModeChange: (mode: AIMode) => void;
}
export function AIAgentModeSelector({
  currentMode,
  loading,
  onModeChange
}: AIAgentModeSelectorProps) {
  const { t } = useTranslation('conversations');
  const modes = [{
    key: 'auto' as AIMode,
    label: t('aiModes.autoLabel'),
    icon: Bot,
    description: t('aiModes.autoDesc'),
    color: 'text-green-600 dark:text-green-400'
  }, {
    key: 'suggestions' as AIMode,
    label: t('aiModes.assistLabel'),
    icon: BotMessageSquare,
    description: t('aiModes.assistDesc'),
    color: 'text-blue-600 dark:text-blue-400'
  }, {
    key: 'manual' as AIMode,
    label: t('aiModes.manualLabel'),
    icon: User,
    description: t('aiModes.manualDesc'),
    color: 'text-gray-600 dark:text-gray-400'
  }];
  return <TooltipProvider>
      <div className="flex items-center gap-1 bg-muted/50 rounded-md p-1 px-0 py-px my-0">
        {modes.map(mode => {
        const Icon = mode.icon;
        const isActive = currentMode === mode.key;
        return <Tooltip key={mode.key}>
              <TooltipTrigger asChild>
                <Button variant={isActive ? "default" : "ghost"} size="sm" onClick={() => onModeChange(mode.key)} disabled={loading} className={`
                    h-7 px-2 text-xs transition-all
                    ${isActive ? 'bg-background text-foreground font-medium shadow-sm border border-border' : 'text-muted-foreground hover:text-foreground hover:bg-background/50'}
                  `}>
                  <Icon className={`h-3 w-3 mr-1 ${isActive ? mode.color : ''}`} />
                  {mode.label}
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p className="text-sm font-medium">{mode.label}</p>
                <p className="text-xs text-muted-foreground max-w-48">
                  {mode.description}
                </p>
              </TooltipContent>
            </Tooltip>;
      })}
      </div>
    </TooltipProvider>;
}